<p-table [value]="viewModel" [autoLayout]="true" [rowHover]="sizeState === 'TABLE'" sortField="uploadedDate" [sortOrder]="-1" (onSort)="onSort()" lb-events (afterViewInit)="registerObserver()">
	<ng-template pTemplate="header">
		<ng-container [ngSwitch]="sizeState">
			<ng-container *ngSwitchCase="'TABLE'">
				<tr>
					<th pSortableColumn="name">Name
						<p-sortIcon field="name"></p-sortIcon>
					</th>

					<th pSortableColumn="extension">Ext.
						<p-sortIcon field="extension"></p-sortIcon>
					</th>

					<th pSortableColumn="uploadedDate">Uploaded
						<p-sortIcon field="uploadedDate"></p-sortIcon>
					</th>

					<th></th>
				</tr>
			</ng-container>
			<ng-container *ngSwitchCase="'CARD'">

			</ng-container>
		</ng-container>
	</ng-template>

	<ng-template pTemplate="body" let-fileRow>
		<ng-container [ngSwitch]="sizeState">
			<ng-container *ngSwitchCase="'TABLE'">
				<tr class="table-row">
					<td>
						<div class="p-grid p-nogutter file-detail-container">
							<div class="p-col-9">
								<lb-file-detail-listing [file]="fileRow.file" [usePreview]="false" title="Open file details"></lb-file-detail-listing>
							</div>
							<div class="p-col-2 p-offset-1">
								<a class="w-100" href="/#/files?fileId={{fileRow.id}}" target="_blank" title="Open file details in new tab">
									<span class="pi pi-external-link"></span>
								</a>
							</div>
						</div>
					</td>

					<td>{{fileRow.extension | lowercase}}</td>

					<td>{{fileRow.uploadedDate | date:'MM/dd/yyyy HH:mm'}}</td>

					<td class="button-column">
						<ng-container *ngTemplateOutlet="buttons; context: { $implicit: fileRow, showLabel: true }"></ng-container>
					</td>
				</tr>
			</ng-container>
			<ng-container *ngSwitchCase="'CARD'">
				<tr>
					<td class="p-p-0" [style]="{ width: cardWidth, maxWidth: cardWidth}">
						<p-card class="file-card">
							<div class="p-d-flex p-flex-column p-jc-center">
								<lb-file-detail-listing [file]="fileRow.file" [usePreview]="false" title="Open file details"></lb-file-detail-listing>
								<div class="p-d-flex p-jc-evenly p-mt-2">
									<ng-container *ngTemplateOutlet="buttons; context: { $implicit: fileRow, showLabel: false, showOpenExternal: true }"></ng-container>
								</div>
							</div>
						</p-card>
					</td>
				</tr>
			</ng-container>
		</ng-container>
	</ng-template>

</p-table>

<ng-template #buttons let-fileRow let-showLabel="showLabel" let-showOpen="showOpenExternal">
	<button *ngIf="canPreviewType(fileRow.file)" pButton pRipple [label]="showLabel ? 'View' : ''" icon="pi {{getPreviewIcon(fileRow.type)}}" title="View"
			[class]="'p-button-sm p-button-rounded p-button-info p-button-outlined ' + (showLabel ? 'w-100' : '')" (click)="previewFile(fileRow.file, $event)">
	</button>
	<button pButton pRipple [label]="showLabel ? 'Download' : ''" icon="pi pi-download" title="Download"
			[class]="'p-button-sm p-button-rounded p-button-info p-button-outlined ' + (showLabel ? 'w-100' : '')" (click)="downloadFile(fileRow.href)">
	</button>
	<button *ngIf="showOpen" pButton pRipple [label]="showLabel ? 'Open in new window' : ''" icon="pi pi-external-link" title="Open in new window"
			[class]="'p-button-sm p-button-rounded p-button-info p-button-outlined ' + (showLabel ? 'w-100' : '')" (click)="openExternalLink(fileRow.file)" >
	</button>
</ng-template>